import React from 'react';
import { connect } from 'react-redux';

// Utils
import clsx from 'clsx';

import {
  Element,
  Color,
  FontType,
  Align,
  HeroBanner,
  Typography,
  Breakpoint
} from '@americanexpress/aqx-components';

// selectors
import { getPageData } from 'src/universal/redux/page';

import './__styles__/index.scss';

export const ProductAgnosticHero = ({
  content: { title = '', imageURL = '', header = '' } = {}
}) => (
  <Breakpoint>
    {({ sm } = {}) => (
      <div className={clsx('product-agnostic-hero', { 'vac-hero-section': sm })}>
        <HeroBanner
          qeId="herobanner"
          $backgroundSize="294px 281px"
          $backgroundRepeat="repeat"
          data={{
            image: {
              _default: imageURL
            }
          }}
        >
          <Element
            className="hero-with-filters-text"
            theme={{
              marginBottom: !sm && 50
            }}
          >
            {title && (
              <Typography
                Component="h1"
                theme={{
                  color: Color.White,
                  textAlign: Align.Left,
                  textHeading: sm ? 3 : 4,
                  horizontallyFluid: true,
                  fontType: FontType.BentonRegular,
                  marginBottom: 15
                }}
              >
                {title}
              </Typography>
            )}
            {header && (
              <Typography
                Component="h2"
                theme={{
                  color: Color.White,
                  textAlign: Align.Left,
                  textHeading: sm ? 4 : 5,
                  horizontallyFluid: true,
                  fontType: FontType.BentonRegular
                }}
              >
                {header}
              </Typography>
            )}
          </Element>
        </HeroBanner>
      </div>
    )}
  </Breakpoint>
);

const mapStateToProps = state => ({
  content: getPageData(state)?.productAgnosticHero
});

export default connect(mapStateToProps)(ProductAgnosticHero);
